/**
 * Agency block — editor component.
 *
 * @package
 * @since   3.5.0
 */

import { __ } from '@wordpress/i18n';
import createPeopleArchiveEdit from '../shared/PeopleArchiveEdit';

const ORDERBY_OPTIONS = [
	{ label: __( 'Name', 'havenlytics' ), value: 'name' },
	{ label: __( 'Date added', 'havenlytics' ), value: 'date' },
];

export default createPeopleArchiveEdit( 'havenlytics/agency', ORDERBY_OPTIONS );
